export default __webpack_public_path__ + "images/6c011b17d65e9129a0d2039a1b5792bf-gaming_small.webp";